import React from 'react';
import PropTypes from 'prop-types';

import AnonShibbolethLoginContainer from './AnonShibbolethLogin/AnonShibbolethLoginContainer';
import NotAnonShibbolethLoginContainer from './NotAnonShibbolethLogin/NotAnonShibbolethLoginContainer';

function AnonymousUser({ isAnonShibbolethLogin }) {
  return isAnonShibbolethLogin ? <AnonShibbolethLoginContainer /> : <NotAnonShibbolethLoginContainer />;
}

AnonymousUser.propTypes = {
  isAnonShibbolethLogin: PropTypes.bool,
};

export default AnonymousUser;
